import { ReactElement } from 'react';
import { NEW_NON_EMPLOYEE_KEYS } from 'pages/NewNonEmployee/_const';
import CustomRadioGroup from '../base/CustomRadioGroup';

/**
 * Prompt user for input: site admin
 * @returns {ReactElement} ask user to indicate if new user is a site admin
 */
const CommunityConnectLocation = () => {
	return (
		<CustomRadioGroup
			id={'wave-one-location'}
			label={
				<>
					Is the new Community Connect User you are provisioning going
					to be associated with any of the following
					locations/practices?
					<ul>
						<li>Dr. Gupta Practice</li>
						<li>Hamilton Health</li>
						<li>Laurel Health/North Penn</li>
					</ul>
				</>
			}
			options={[
				{ key: 'Yes', label: 'Yes', value: true },
				{ key: 'No', label: 'No', value: false },
			]}
			name={NEW_NON_EMPLOYEE_KEYS.WAVE_ONE_LOCATION}
			required
			row
		/>
	);
};
export default CommunityConnectLocation;
